import React from "react";
import { CardBody } from "reactstrap";
import Tips from "../Partial/Tips";
import CompleteVerification from "../Partial/CompleteVerification";
import { IMAGE_TYPES } from "~/constants/imageTypes";

interface PassportInstructionsProps {
  frontSrc: string;
  selfieSrc: string;
  startCapture: any;
  back: () => void;
  complete: () => void;
}

const PassportInstructions = ({ frontSrc, selfieSrc, startCapture, back, complete }: PassportInstructionsProps) => {

  /********** OTHER **********/
  const isPassportInfo = !frontSrc;
  const isSelfieInfo = frontSrc;
  const isPassportComplete = frontSrc && selfieSrc;

  return <React.Fragment>
    <div className="id-instructions">
      <CardBody>
        {isPassportComplete ?
          <CompleteVerification
            imageType={IMAGE_TYPES.PASSPORT}
            frontSrc={frontSrc}
            selfieSrc={selfieSrc}
            startCapture={startCapture}
            complete={complete}
          /> :
          <Tips
            isPassportInfo={isPassportInfo}
            isSelfieInfo={isSelfieInfo}
            startCapture={startCapture}
            back={back}
          />}
      </CardBody>
    </div>
  </React.Fragment>
}

export default PassportInstructions;